module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#photo",
      toString: function () {
        return this.url;
      }
    }